import React, { useState, useEffect } from "react";

export function Compressing() {
  const [className, setClassName] = useState("background");

  useEffect(() => {
    setClassName("background shrinking");
  }, []);
  return (
    <>
      <div className="compressing">
        <div className={className}></div>
        <div className="text">Compressing style...</div>
      </div>
    </>
  );
}
